module.exports = __webpack_public_path__ + "img/CBX.545aa362.png";